var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalBonds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67478",
    "data-name": "Group 67478",
    transform: "translate(-984 -756)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22414",
    "data-name": "Rectangle 22414",
    width: 72,
    height: 72,
    transform: "translate(984 756)",
    fill: "#f2fff9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67451",
    "data-name": "Group 67451",
    transform: "translate(1003.334 772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67450",
    "data-name": "Group 67450",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67449",
    "data-name": "Group 67449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80504",
    "data-name": "Path 80504",
    d: "M72.582,9.226l-5.807-5.81A11.6,11.6,0,0,0,58.525,0H51a8.343,8.343,0,0,0-8.333,8.333V31.666A8.343,8.343,0,0,0,51,40H67.667A8.343,8.343,0,0,0,76,31.666V17.475a11.585,11.585,0,0,0-3.418-8.248Zm-2.357,2.357a8.305,8.305,0,0,1,1.3,1.75H64.333a1.667,1.667,0,0,1-1.667-1.667V4.473a8.35,8.35,0,0,1,1.752,1.3Zm2.442,20.083a5,5,0,0,1-5,5H51a5,5,0,0,1-5-5V8.333a5,5,0,0,1,5-5h7.525c.273,0,.538.053.808.078v8.255a5,5,0,0,0,5,5h8.255c.025.27.078.533.078.808Z",
    transform: "translate(-42.667 0)",
    fill: "#3bbf83"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBonds);
export default __webpack_public_path__ + "static/media/total-bonds.a60d99f56eb558d1a26f398663ebd0ca.svg";
export { ForwardRef as ReactComponent };